export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accede al instante desde cualquier dispositivo, sin esperas ni envíos físicos.'
  },
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. Usamos pasarelas de pago certificadas internacionalmente. Tu información está 100% protegida.'
  },
  {
    q: '¿Es un solo pago?',
    a: 'Sí. Pago único sin suscripción. Acceso de por vida al material.'
  },
  {
    q: '¿Sirve para entrenadores con poca experiencia?',
    a: 'Totalmente. El Bono #1 "Plan de Arranque 7 Días" está diseñado exactamente para eso. Te guía paso a paso sin perderte entre 350 páginas.'
  },
  {
    q: '¿Puedo usarlo solo para una categoría concreta?',
    a: 'Sí. Cada tomo tiene adaptaciones para Alevín, Infantil, Cadete y Juvenil. Usas lo que necesitas.'
  },
  {
    q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
    a: 'El Tomo 2 incluye variantes de cada ejercicio (fácil, medio, difícil) para que puedas adaptar en tiempo real. Todos progresan sin aburrir a los avanzados.'
  },
  {
    q: '¿En qué formato vienen los archivos?',
    a: 'PDF descargable, imprimible y optimizado para móvil. Funciona en cualquier dispositivo.'
  },
  {
    q: '¿Tiene garantía de devolución?',
    a: 'Sí. Garantía de 7 días: si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  }
];
